import { render, staticRenderFns } from "./ForgotChangePass.vue?vue&type=template&id=2c3e0730"
import script from "./ForgotChangePass.vue?vue&type=script&lang=js"
export * from "./ForgotChangePass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports